var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-register-base", {
        attrs: {
          loading: _vm.loading,
          model: _vm.model,
          title: _vm.title,
          icon: "mdi-book-open-page-variant",
          show: _vm.dialog,
          maxWidth: "40%",
          textButtonSave: "Gerar Diários",
        },
        on: {
          onSave: _vm.save,
          "update:model": function ($event) {
            _vm.model = $event
          },
          "update:show": function ($event) {
            _vm.dialog = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "form",
            fn: function () {
              return [
                _c(
                  "v-container",
                  [
                    _vm.timeSheetDisabledMessage
                      ? _c(
                          "v-alert",
                          {
                            staticClass: "mb-4",
                            attrs: {
                              type: "warning",
                              outlined: "",
                              dense: "",
                              icon: "mdi-alert-outline",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.timeSheetDisabledMessage) + ". "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("sys-select-company", {
                              attrs: {
                                model: _vm.model.companies,
                                label: "Empresa (Opcional)",
                                multiple: "",
                                dense: "",
                                "select-all": "",
                                "filter-time-sheet": "",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(
                                    _vm.model,
                                    "companies",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _vm.allowAssociateWorkTimes
                          ? _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("s-switch", {
                                  attrs: {
                                    "text-helper":
                                      "Lista também os campus de períodos associados (mesmo ano e período, ex.: SIGA)",
                                    label:
                                      "Incluir campus de períodos associados",
                                    inset: "",
                                  },
                                  model: {
                                    value: _vm.includeAssociatedCampuses,
                                    callback: function ($$v) {
                                      _vm.includeAssociatedCampuses = $$v
                                    },
                                    expression: "includeAssociatedCampuses",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "8" } },
                          [
                            _c("sys-select-campus", {
                              attrs: {
                                model: _vm.model.campuses,
                                error: _vm.errors.length > 0,
                                errors: _vm.errors.campuses,
                                label: "Campus*",
                                multiple: "",
                                "only-active": "",
                                "select-all": "",
                                autofocus: "",
                                "filter-relation": "groups",
                                "associated-work-times":
                                  _vm.includeAssociatedCampuses,
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(_vm.model, "campuses", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("sys-select-shift", {
                              attrs: {
                                model: _vm.model.shifts,
                                error: _vm.errors.length > 0,
                                errors: _vm.errors.shifts,
                                label: "Turno*",
                                multiple: "",
                                "only-active": "",
                                "select-all": "",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(_vm.model, "shifts", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("sys-select-occurrence-sheet-type", {
                              attrs: {
                                model: _vm.model.types,
                                error: _vm.errors.length > 0,
                                errors: _vm.errors.types,
                                label: "Tipo*",
                                dense: "",
                                multiple: "",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(_vm.model, "types", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                error: _vm.errors.length > 0,
                                "error-messages": _vm.errors.year,
                                label: "Ano*",
                                disabled: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.model.year,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "year", $$v)
                                },
                                expression: "model.year",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "4" } },
                          [
                            _c("sys-select-month", {
                              attrs: {
                                model: _vm.model.month,
                                dense: "",
                                error: _vm.errors.length > 0,
                                errors: _vm.errors.month,
                                label: "Mês*",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(_vm.model, "month", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                "text-helper":
                                  "Consolidar todos os campus na folha de ponto",
                                label: "Consolidar Campus",
                                inset: "",
                              },
                              model: {
                                value: _vm.model.consolidate_campuses,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "consolidate_campuses",
                                    $$v
                                  )
                                },
                                expression: "model.consolidate_campuses",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                "text-helper":
                                  "Consolidar todos os turnos na folha de ponto",
                                label: "Consolidar Turno",
                                inset: "",
                              },
                              model: {
                                value: _vm.model.consolidate_shifts,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "consolidate_shifts", $$v)
                                },
                                expression: "model.consolidate_shifts",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                "text-helper": "Incluir intervalos",
                                label: "Intervalo",
                                inset: "",
                              },
                              model: {
                                value: _vm.model.include_ranges,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "include_ranges", $$v)
                                },
                                expression: "model.include_ranges",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                "text-helper": "Consolidar horários por data",
                                label: "Consolidar Datas",
                                inset: "",
                              },
                              model: {
                                value: _vm.model.consolidade_dates,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "consolidade_dates", $$v)
                                },
                                expression: "model.consolidade_dates",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                "text-helper":
                                  "Exibir feriados no ponto do professor",
                                label: "Feriado",
                                inset: "",
                              },
                              model: {
                                value: _vm.model.show_holidays,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "show_holidays", $$v)
                                },
                                expression: "model.show_holidays",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("s-switch", {
                              attrs: {
                                "text-helper":
                                  "Gerar folhas de ponto apenas para novos registros (ignorar professores que já possuem folhas criadas para o período)",
                                label: "Gerar novos registros",
                                inset: "",
                              },
                              model: {
                                value: _vm.model.create_only_new,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "create_only_new", $$v)
                                },
                                expression: "model.create_only_new",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("sys-select-teacher", {
                              attrs: {
                                model: _vm.model.teacher_id,
                                error:
                                  _vm.errors.teacher_id &&
                                  _vm.errors.length > 0,
                                data: _vm.model.teacher,
                                errors: _vm.errors.teacher_id,
                                companyIds: _vm.selectedCompanyIds,
                                label:
                                  "Professor (Opcional - Deixar vazio para gerar de todos)",
                                autoComplete: "",
                                clearable: "",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(
                                    _vm.model,
                                    "teacher_id",
                                    $event
                                  )
                                },
                                "update:data": function ($event) {
                                  return _vm.$set(_vm.model, "teacher", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("emc-alert-snackbar", {
                  attrs: {
                    show: !!_vm.message.length,
                    message: _vm.message,
                    color: _vm.error ? "error" : "success",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", scrollable: "" },
          model: {
            value: _vm.showSignedDialog,
            callback: function ($$v) {
              _vm.showSignedDialog = $$v
            },
            expression: "showSignedDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "error white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v("mdi-alert"),
                  ]),
                  _vm._v(" Folhas de Ponto Assinadas "),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("p", [
                    _vm._v(
                      "Os seguintes professores possuem folhas com assinatura em andamento ou finalizadas e não podem ser regeneradas:"
                    ),
                  ]),
                  _c("v-simple-table", {
                    attrs: { dense: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    attrs: { scope: "col" },
                                  },
                                  [_vm._v("Professor")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    attrs: { scope: "col" },
                                  },
                                  [_vm._v("Status da Assinatura")]
                                ),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.signedSheets, function (sheet) {
                                return _c("tr", { key: sheet.teacher_id }, [
                                  _c("td", [
                                    _vm._v(_vm._s(sheet.teacher_name)),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            small: "",
                                            color:
                                              sheet.sign_status ===
                                              "Documento Assinado"
                                                ? "success"
                                                : "warning",
                                            dark: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(sheet.sign_status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showSignedDialog = false
                        },
                      },
                    },
                    [_vm._v("Fechar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", scrollable: "" },
          model: {
            value: _vm.showSkippedDialog,
            callback: function ($$v) {
              _vm.showSkippedDialog = $$v
            },
            expression: "showSkippedDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "warning white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v("mdi-information"),
                  ]),
                  _vm._v(" Processo Iniciado com Aviso "),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: { type: "success", dense: "" },
                    },
                    [
                      _vm._v(
                        " O processo de geração foi iniciado com sucesso! "
                      ),
                    ]
                  ),
                  _c("p", [
                    _vm._v(
                      "Os seguintes professores possuem folhas assinadas e foram "
                    ),
                    _c("strong", [_vm._v("ignorados")]),
                    _vm._v(" (suas folhas não serão alteradas):"),
                  ]),
                  _c("v-simple-table", {
                    attrs: { dense: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    attrs: { scope: "col" },
                                  },
                                  [_vm._v("Professor")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left",
                                    attrs: { scope: "col" },
                                  },
                                  [_vm._v("Motivo")]
                                ),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.skippedSheets, function (sheet) {
                                return _c("tr", { key: sheet.teacher_id }, [
                                  _c("td", [
                                    _vm._v(_vm._s(sheet.teacher_name)),
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "success",
                                            dark: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(sheet.sign_status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showSkippedDialog = false
                        },
                      },
                    },
                    [_vm._v("Entendi")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }